const Mustache = require('mustache');
import { Movax } from './Movax';

/**
 * Contact form handler in Spare Part Cart page
 *
 *
 */

export class SparePartCartContact {

  private contactFormId: string;  //sparepart-cart-contact-form
  private contactForm: Element;
  private contactTemplateId: string;
  private cartAdressesTemplateId: string;
  private addressSummaryId: string;
  private updateAddressButton: Element;
  private shippingRadioSelection: any;
  private submitContainer: Element;
  private ajaxEndpoint: string;
  private language: string;
  private summaryUpdated: boolean;
  private localizations: any;
  private contactDetailsStorageKey: string = 'cartDetails';
  private contactDetailsStorage: any;
  private storageTimeout: number = 24 * 60 * 60 * 1000;


  constructor() {
    this.contactFormId = 'sparepart-cart-contact-form';
    this.contactTemplateId = 'js-sparepart-cart-contact-template';
    this.cartAdressesTemplateId = 'js-sparepart-cart-contact-adresses';
    this.addressSummaryId = 'address-summary';

    //summary submit button container - hidden by default
    this.submitContainer = document.querySelector('.js-sparepart-order-submit');

    this.contactForm = document.getElementById(this.contactFormId);

    this.ajaxEndpoint = '/stage-ajax/sparepart_cart/';
    this.language = document.documentElement.lang;
    this.summaryUpdated = false;
    this.localizations = (window as any).LOCALIZATIONS?.sparepartcart || {};

    this.contactDetailsStorage = Movax.storage.getLocalStorageItem(this.contactDetailsStorageKey);
  }

  /**
   * attach contact form listener
   *
   */
  public attachListeners() {

    //if local storage found, populate form fields
    if(this.contactForm && this.contactDetailsStorage) {
      this.populateFormFields(this.contactDetailsStorage);
    }

    if (this.contactForm) {
      //update address button
      this.updateAddressButton = this.contactForm.querySelector('.js-update-address');
      this.updateAddressButton.addEventListener('click', (event) => {
        const formFields = this.collectFormFields();
        this.validateForm(formFields);
      });

      //listen to form changes
      this.contactForm.querySelectorAll('input').forEach((input) => {
        input.addEventListener('change', (event) => {
          this.onInputChange(event);
        });
      });
    }


  }

  /**
   * Populate form fields from local storage
   * @param {object} formFieldsStorage
   */
  public populateFormFields(formFieldsStorage : any){

    for (const key in formFieldsStorage){
      if(key !== 'toDifferentAddress'){
        document.forms[this.contactFormId][key].value = formFieldsStorage[key];
      }else{
        const targetId = document.forms[this.contactFormId][key].getAttribute('aria-controls');
        document.forms[this.contactFormId][key].checked = true;
        const extraContent = document.getElementById(targetId);
        extraContent.classList.remove('hidden');
      }

    }

  }

  /**
   * Collect form fields
   *
   * @returns{object}
   */
  public collectFormFields() {

    const form = this.contactForm as HTMLFormElement;
    const contactFormData: any = new FormData(form);
    const formFields: any = {};

    contactFormData.forEach((value, key) => {
      formFields[key] = value;
    });

    //populate shipping fields from invoice if shipping address not separate
    if (!formFields.toDifferentAddress) {
      for (var key in formFields) {
        //skip shipping type radio select
        if (key.includes('shipping') && key !== 'shippingType') {
          const invoiceKey = key.replace('shipping', '').toLowerCase();
          formFields[key] = formFields[invoiceKey];
        }
      }
    }

    return formFields;
  }


  /**
   * Validate form fields - validated by sending to Stage
   *
   * @param formFields
   */
  public async validateForm(formFields) {
    let validated = false;
    const errorContainer = document.getElementById('js-contact-form-error');

    //xhr params
    const params = {
      action: 'validateAddressForm',
      fields: JSON.stringify(formFields),
      language: this.language
    };

    //remove possible field-errors before validation
    document.querySelectorAll('.field-error').forEach(e => e.remove());

    try {
      const result = await this.makeAjaxRequest(params);
      this.updateAddressButton.classList.add('button--loading');

      //error -> show error field
      if (result.status === 'error') {
        this.showErrorFields(result.data.errors);
        throw new Error(result.message);
      }
      errorContainer.innerHTML = '';
      validated = true;
    } catch (error) {
      this.submitContainer.classList.add('hidden');
      errorContainer.innerHTML = error;
      validated = false;
    } finally {
      this.updateAddressButton.classList.remove('button--loading');
    }

    //check shipping type
    if (!formFields.shippingType) {
      validated = false;
    }

    if (validated) {
      //show order submit container
      this.submitContainer.classList.remove('hidden');
      //update address to summary
      this.updateFormAddress(formFields);
      //disable update button
      this.updateAddressButton.setAttribute('disabled', 'disabled');
      this.updateAddressButton.classList.add('button--disabled');

      //set formFields to localstorage
      Movax.storage.setLocalStorageItem(this.contactDetailsStorageKey, formFields, this.storageTimeout);

    }

  }

  /**
   * Show error in the form labels
   * @param errorFields
   */
  public showErrorFields(errorFields) {
    Object.keys(errorFields).map(field => {
      const fieldLabel = document.getElementById('js-cart-contact-' + field);
      const spanError = '<span class="field-error">' + errorFields[field][0] + '</span>';
      fieldLabel.insertAdjacentHTML('beforeend', spanError);
    });
  }

  /**
   * update adress summary from the form data
   *
   * @param formFields - form with address information
   */
  public updateFormAddress(formFields) {

    const addressContainer = document.getElementById(this.addressSummaryId);
    const contactTemplate = document.getElementById(this.contactTemplateId).textContent;
    const cartAdressesTemplate = document.getElementById(this.cartAdressesTemplateId).textContent;

    //concatenate address template
    const concatAddressTemplate = `
      {{address}}<br>
      {{city}}, {{state}} {{zip}}<br>
      {{country}}
      `;

    //gather address information for render
    const concatInvoiceAddress = Mustache.render(concatAddressTemplate, {
      address: formFields.address1 + ' ' + formFields.address2,
      city: formFields.city,
      state: formFields.state,
      zip: formFields.zip,
      country: formFields.country
    });

    //gather address information for render
    const concatShippingAddress = Mustache.render(concatAddressTemplate, {
      address: formFields.shippingAddress1 + ' ' + formFields.shippingAddress2,
      city: formFields.shippingCity,
      state: formFields.shippingState,
      zip: formFields.shippingZip,
      country: formFields.shippingCountry
    });

    //Invoice address
    const invoiceAddress = {
      company: formFields.company,
      vat_number: formFields.vat_number,
      reference_number: formFields.reference_number,
      name: formFields.namefield,
      address: concatInvoiceAddress,
      email: formFields.email,
      tel: formFields.tel
    };

    //shipping address
    const shippingAddress = {
      company: formFields.shippingCompany,
      name: formFields.shippingName,
      address: concatShippingAddress,
      email: formFields.shippingEmail,
      tel: formFields.shippingTel
    };

    const addresses = {
      invoice: Mustache.render(contactTemplate, invoiceAddress),
      shipping: Mustache.render(contactTemplate, shippingAddress)
    };

    //create new markup and update summary
    const addressMarkup = Mustache.render(cartAdressesTemplate, addresses);
    addressContainer.innerHTML = addressMarkup;
    addressContainer.setAttribute('data-addresses', JSON.stringify(formFields));
    this.summaryUpdated = true;
    this.submitContainer.querySelector('#js-summary-warning').innerHTML = '';
  }

  private onInputChange(event) {
     // add shippingType selection into Summary
    if (event.target?.name === 'shippingType'){
      this.updateShippingType();
    } else {
      //warn user about unupdated data
      if(this.summaryUpdated) {
        this.summaryUpdated = false;
        this.submitContainer.querySelector('#js-summary-warning').innerHTML = this.localizations.updateWarning;
        //enable update button
        this.updateAddressButton.removeAttribute('disabled');
        this.updateAddressButton.classList.remove('button--disabled');
      }
    }
  }


  /**
   *  Update summary shipping type
   */
  public updateShippingType() {
    const shippingTypeContainer: Element = document.getElementById('js-shipping-type');

    if (shippingTypeContainer) {
      const shippingChoice: any = event.currentTarget;
      shippingTypeContainer.innerHTML = shippingChoice.value;
    }

  }

  /**
   * Empty invoice and shipping details from local storage
   */
  public removeContactDetails() {
    return Movax.storage.removeLocalStorageItem(this.contactDetailsStorageKey);
  }

  /**
 * Make ajax request
 *
 * @param params parameters as object or serialized string
 * @returns {object} return object should contain status, message, data
 */
  private async makeAjaxRequest(params: object) {

    if (!this.ajaxEndpoint) {
      throw new Error('Form submission failed. Endpoint undefined.');
    }

    return Movax.xhr.get(this.ajaxEndpoint, params);
  }

  /**
   * returns contact form element
   */
  public getFormContainer () {
    return this.contactForm
  }

}
